import { Canvas3d } from "./Canvas3d.js";

type Mutable<T> = { -readonly [P in keyof T]: T[P] };

export interface BaseElement3dOptions {
    canvas: Canvas3d;
    container?: THREE.Object3D | "auto";
    opacity?: number;
}

export class BaseElement3d {

    public readonly element: THREE.Object3D;

    protected readonly _canvas: Canvas3d;

    private _opacity: number = 1;
    private _materials: {
        material: THREE.Material;
        initialOpacity: number;
    }[] = [];

    protected create(options: BaseElement3dOptions) {
        options = e5.object.merge({
            container: "auto",
            opacity: 1
        } as BaseElement3dOptions, options);

        (this as Mutable<BaseElement3d>).element = new THREE.Object3D();

        //@ts-ignore
        this._canvas = options.canvas;

        if (options.container) {
            var container = options.container === "auto" ? this._canvas.scene : options.container;
            container.add(this.element);
        }
        this.opacity = options.opacity;
    }

    public get opacity(): number {
        return this._opacity;
    }

    public set opacity(value: number) {
        value = e5.Calc.clamp(value, 0, 1);
        if (this._opacity === value) {
            return;
        }
        this._opacity = value;
        this.element.visible = value > 0;

        for (var info of this._materials) {
            var m = info.material;
            m.opacity = info.initialOpacity * this._opacity;
            // m.transparent = m.opacity < 1;
            m.needsUpdate = true;
        }
    }

    protected addMaterial<T extends THREE.Material>(m: T): T {
        this._materials.push({
            initialOpacity: m.opacity,
            material: m
        });
        m.opacity = this._opacity * m.opacity;
        // m.transparent = m.opacity < 1;
        m.needsUpdate = true;
        return m;
    }
}